<template>
	<v-form
		class="create-post-form"
		ref="form"
		v-model="valid"
		lazy-validation
		@submit.prevent="validateAndSubmit"
	>
		<div class="create-post">
			<div class="create-thread-modal__scroll-wrapper">
				<div class="create-post__title-container">
					<span class="title-video">Title</span>
					<v-text-field
						class="create-post__field-input-title"
						v-model="fields.thread_title"
						:error="!!errors.thread_title"
						:error-messages="field_errors.required"
						:rules="rules.required"
						label="Add title..."
						required
						solo
					/>
					<p
						class="red--text text-center"
						v-for="(error, index) in errors"
						:key="error + '-' + index"
						style="width: 100%"
					>
						{{ error }}
					</p>
				</div>

				<div class="create-post__descript-container mt-3">
					<div class="d-flex justify-space-between">
						<span class="title-video">Description</span>
						<button
							:disabled="fields.thread_text === ''"
							type="button"
							@click="toggleDescription"
						>
							<Icon type="up" :size="24" color="#9B9B9B" />
						</button>
					</div>
					<div v-if="collapsed" class="text-collapsed">
						{{ trimmedText }}
					</div>

					<v-textarea
						v-else
						color="#4a4a4a"
						class="create-post__field-input-title"
						label="Add description..."
						v-model="fields.thread_text"
						:error-messages="field_errors.required"
						:error="!!errors.thread_text"
						:rules="rules.required"
						auto-grow
						required
						solo
						rows="3"
					/>
					<p
						class="red--text text-center"
						v-for="(error, index) in errors"
						:key="error + '-' + index"
						style="width: 100%"
					>
						{{ error }}
					</p>
				</div>
				<div class="create-post__chapters-container mt-3 pr-1">
					<div class="create-post__chapters-container__info">
						<span class="title-video">Post Audience</span>
						<div
							v-if="visibleChapters"
							class="create-post__chapters-container__info__chapters"
						>
							<span class="create-post__chapters-container__info__chapters__chapter">
								{{ visibleChapters }}
							</span>
						</div>
					</div>
					<div
						class="u-cursor-pointer"
						@click="openChaptersModal"
						@mouseenter="isChaptersIconHovered = true"
						@mouseleave="isChaptersIconHovered = false"
					>
						<Icon
							type="chevron_right"
							:size="16"
							:color="isChaptersIconHovered ? 'var(--primary_color)' : '#9b9b9b'"
							:pr="8"
						/>
					</div>

					<ChaptersModal
						:items="chapterModalItem"
						v-model="fields.chapter_ids"
						:show="isChaptersModal"
						@closeChaptersModal="closeChaptersModal"
					/>
				</div>

				<div v-if="isPollSectionVisible" class="pool-container">
					<div class="pool-container__title-container">
						<span class="pool-container__title-container__title">Poll</span>
						<div class="pool-container__title-container__icon-container">
							<div :style="{ cursor: edit ? 'unset' : 'pointer' }" @click="clearPoll">
								<Icon
									type="delete"
									:color="edit ? '#9b9b9b' : 'var(--button-icon-tint)'"
									:size="24"
								/>
							</div>
							<div class="u-cursor-pointer" @click="hidePool">
								<Icon type="up" :size="24" color="#9b9b9b" />
							</div>
						</div>
					</div>
					<div class="pool-container__answer-container">
						<div class="pool-container__answer-container__input-container">
							<label
								class="pool-container__answer-container__label mt-3"
								for="poll_text"
								>Question</label
							>
							<textarea
								:disabled="isPollEdit"
								class="pool-container__answer-container__input"
								v-model="fields.poll_question"
								id="poll_text"
								placeholder="..."
								rows="1"
								style="overflow-y: hidden; resize: none"
								@input="autoResize"
							></textarea>
						</div>
					</div>
					<div>
						<div
							v-for="(answer, index) in poolArray"
							:key="answer.poll_answer_id || 'new-' + index"
							class="pool-container__pool_group d-flex justify-space-between align-center mt-2"
						>
							<div class="pool-container__pool_group__input-container">
								<span class="pool-container__pool_group__number"
									>Option {{ index + 1 }}</span
								>
								<input
									:disabled="isPollEdit"
									class="pool-container__pool_group__input"
									v-model="answer.poll_answer"
									type="text"
									placeholder="Add option"
								/>
							</div>
							<div
								:style="{
									cursor: edit ? 'unset' : 'pointer',
								}"
								@click="removeAnswer(index)"
							>
								<Icon type="delete" :size="16" color="#9B9B9B" />
							</div>
						</div>
					</div>
					<div class="pool-container__answer-container__end-time">
						<label
							class="pool-container__answer-container__end-time__label"
							for="poll_length"
						>
							Poll Length
						</label>
						<button
							class="pool-container__answer-container__end-time__button ml-1"
							:style="{
								cursor: edit ? 'unset' : 'pointer',
							}"
							@click="toggleAnswerModal"
							type="button"
						>
							{{ selectedPollLength }}
							<Icon
								type="up"
								:size="24"
								:color="fields.poll_length ? '#9B9B9B' : 'var(--primary_color)'"
							/>
						</button>
						<div
							class="pool-container__answer-container__end-time__modal"
							v-if="isAnswerModal"
						>
							<div
								class="pool-container__answer-container__end-time__modal__container"
							>
								<div
									class="pool-container__answer-container__end-time__modal__item"
									v-for="answer in postTimer"
									:key="answer.id"
								>
									<CustomCheckbox
										:isChecked="answer.id === fields.poll_length"
										:value="answer.id"
										:onChange="() => setPollLength(answer.id)"
									/>
									<span
										class="pool-container__answer-container__end-time__modal__item-label"
									>
										{{ answer.val }}
									</span>
								</div>
							</div>
						</div>
					</div>
					<button
						ref="pollInput"
						type="button"
						:disabled="isPollEdit || poolArray.length >= 10"
						:style="{
							color:
								poolArray.length >= 10 || edit
									? '#9B9B9B'
									: 'var(--text_button_tint)',
							cursor: edit ? 'unset' : 'pointer',
						}"
						class="pool-container__pool_group__button mt-2"
						@click="addAnswer"
					>
						+ Add options
					</button>
				</div>
				<div
					v-if="isLinkSectionVisible && !isPollEdit"
					class="create-post__link-container mt-3"
				>
					<div class="d-flex justify-space-between">
						<span class="title-video">Link</span>
						<div class="u-cursor-pointer" @click="deleteLink">
							<Icon color="var(--button-icon-tint)" type="delete" :size="24" />
						</div>
					</div>
					<v-text-field
						ref="linkInput"
						class="create-post__link-container-input"
						color="red"
						v-model="fields.thread_link"
						auto-grow
						required
						solo
						label="Add link..."
						@blur="formatThreadLink"
						:disabled="!!fields.poll_question"
					/>
				</div>

				<div v-if="isTagsSectionVisible" class="create-post__tags-container mt-3">
					<div class="d-flex justify-space-between">
						<span class="title-video">Tags</span>
						<div class="u-cursor-pointer" @click="deleteTags">
							<Icon color="var(--button-icon-tint)" type="delete" :size="24" />
						</div>
					</div>
					<v-combobox
						ref="tagsInput"
						v-model="chips"
						:items="tagSelectItems"
						item-text="tag"
						label="Add Tags..."
						chips
						multiple
						solo
						@update:search-input="handlerInputTag"
						@change="debug"
						append-icon="mdi-chevron-up"
						class="create-post__field-input tags-select create-post__tags-container__custom-tag"
						:menu-props="{
							contentClass: 'create-post__tags-container__tags-combobox',
						}"
						return-object
					>
						<template v-slot:selection="{ attrs, item, select, selected }">
							<v-chip v-bind="attrs" :input-value="selected">
								<strong style="color: #4a4a4a">{{ item }}</strong>
							</v-chip>
						</template>
					</v-combobox>
				</div>

				<div v-if="isImageSectionVisible && !isPollEdit" class="carousel-wrapper mt-3">
					<div class="d-flex justify-space-between">
						<span class="title-video">Post Image</span>
						<div class="u-cursor-pointer" @click="clearAllPhotos">
							<Icon color="var(--button-icon-tint)" type="delete" :size="24" />
						</div>
					</div>
					<div
						v-if="slider_images.length === 0"
						class="carousel-wrapper__file-container mt-3"
					>
						<v-icon color="#F3F3F6" :size="50">mdi-image</v-icon>
						<div class="carousel-wrapper__file-container-title">
							<div class="d-flex">Drag and Drop</div>
						</div>
						<div class="carousel-wrapper__file-container-description">
							JPG, PNG. Max 30 MB each
						</div>
					</div>
					<div v-else class="carousel mt-3">
						<div class="carousel-track" :style="trackStyle">
							<div
								v-for="(image, index) in slider_images"
								:key="image.id"
								class="carousel-item"
								:class="{
									active: currentIndex === index,
									single: slider_images.length === 1,
								}"
							>
								<img :src="image.image_url" alt="Uploaded Image" />
								<button
									type="button"
									class="remove-btn"
									@click="removeImages(index)"
								>
									<Icon type="close" :size="24" color="var(--accent-color)" />
								</button>
							</div>
						</div>
					</div>
					<div class="indicators">
						<span
							v-if="slider_images.length > 1"
							v-for="(image, index) in slider_images"
							:key="'indicator-' + image.id"
							:class="{ active: currentIndex === index }"
							@click="goToSlide(index)"
						></span>
					</div>
					<div
						:style="{
							color:
								slider_images.length >= 10 ? '#9b9b9b' : 'var(--text_button_tint)',
						}"
						@click="triggerPhotoInput"
						class="carousel-button u-cursor-pointer"
					>
						+ Add Images
						<input
							ref="photoInput"
							id="fileInput"
							type="file"
							accept="image/*"
							@change="handleFileUpload"
							:disabled="slider_images.length >= 10"
						/>
					</div>
				</div>
				<CropperImage
					:src="cropSrc"
					:show.sync="isCropModal"
					@cropped="onCropped"
					@close="closeCropper"
				/>

				<div
					v-if="isVideoSectionVisible && !isPollEdit"
					class="create-post__file-wrapper mt-3"
				>
					<div class="d-flex justify-space-between">
						<span class="title-video">Video Preview</span>
						<div class="u-cursor-pointer" @click="removeImage">
							<Icon type="delete" color="var(--button-icon-tint)" :size="24" />
						</div>
					</div>

					<div class="create-post__file-wrapper__file-container mt-3">
						<div
							class="create-post__file-wrapper__preview-container"
							v-if="isFileLoading || (!fields.thread_image && !isCustomImageLoading)"
						>
							<img
								style="width: 100%; height: 100%"
								:src="videoPreview"
								alt="error"
							/>
						</div>
						<div
							v-else-if="!isFileLoading && !isCustomImageLoading"
							class="create-post__file-wrapper__file-container__images d-flex justify-center"
						>
							<img
								:src="fields.thread_image"
								alt="error"
								class="create-post__file-wrapper__file-container__images__image"
								:style="{ opacity: isCustomImageLoading ? 0 : 1 }"
							/>
							<button
								v-if="isCustomImageUploaded"
								@click="removeCustomImage"
								type="button"
								class="create-post__file-wrapper__file-container__images__image__button"
							>
								<Icon type="close" :size="24" color="var(--accent-color)" />
							</button>
						</div>
						<div
							@click="triggerPreview"
							class="create-post__create-preview u-cursor-pointer"
						>
							+ Add Preview
							<input
								ref="addPreview"
								id="fileInput"
								type="file"
								accept="image/*"
								@change="handleUploadFile"
							/>
						</div>
					</div>

					<div class="create-post__video-container mt-3">
						<span class="title-video">Video Link</span>
						<div
							ref="videoLinkValue"
							tabindex="0"
							@click="openVideoModal"
							class="create-post__video-container__videoLink u-cursor-pointer"
						>
							{{ fields.thread_video || 'Add Link ...' }}
						</div>
						<v-dialog v-model="isVideoModal" max-width="555px" persistent>
							<v-card>
								<div class="video-modal-container">
									<div class="video-modal-container__input-container">
										<span class="video-modal-container__input-container__title">
											Video Link
										</span>
										<input
											class="video-modal-container__input-container__input"
											v-model="fields.thread_video"
											placeholder="Add Link..."
										/>
									</div>
									<div class="video-modal-container__buttons">
										<button
											class="video-modal-container__buttons__cancel-button"
											type="button"
											@click="isVideoModal = false"
										>
											Cancel
										</button>
										<button
											class="video-modal-container__buttons__save-button"
											:style="{
												backgroundColor:
													fields.thread_video === ''
														? '#989898'
														: 'var(--accent-color)',
											}"
											type="button"
											@click="addVideoPreview"
										>
											Save
										</button>
									</div>
								</div>
							</v-card>
						</v-dialog>
						<v-dialog max-width="588px" v-model="isWrongLink" persistent>
							<v-card>
								<div class="wrong-video-link-container">
									<span class="wrong-video-link-container__title">
										This is an erroneous link.
									</span>
									<span class="wrong-video-link-container__title">
										Enter new Vimeo/YouTube format
									</span>
									<button
										@click="closeWrongVideoModal"
										class="wrong-video-link-container__button"
										type="button"
									>
										ok
									</button>
								</div>
							</v-card>
						</v-dialog>
					</div>
				</div>

				<div v-if="isAttachmentSectionVisible && !isPollEdit" class="attachments">
					<div class="d-flex justify-space-between">
						<h3 class="title-video">Attachments</h3>
						<div class="d-flex">
							<div class="mr-1 u-cursor-pointer" @click="clearAttachments">
								<Icon type="delete" :size="24" color="var(--button-icon-tint)" />
							</div>
							<div class="u-cursor-pointer" @click="toggleAttachments">
								<Icon type="up" :size="24" color="#9b9b9b" />
							</div>
						</div>
					</div>
					<div class="attachments__attachments-list">
						<div v-if="moreFiles">
							<div
								v-for="(attachment, index) in this.uploads.slice(0, 3)"
								:key="attachment.upload_id"
								class="attachment-item d-flex justify-space-between"
							>
								<div class="d-flex align-center">
									<PostAttachments
										backgroundColor="#F3F3F6"
										:attachment="attachment"
										style="margin-top: 5px"
									/>
									<span>{{ attachment.filename }}</span>
								</div>
								<button type="button" @click="removeFile(index)" class="delete-btn">
									<Icon type="delete" :size="24" color="#9B9B9B" />
								</button>
							</div>
						</div>
						<div v-if="!moreFiles">
							<div
								v-for="(attachment, index) in this.uploads"
								:key="attachment.upload_id"
								class="attachment-item d-flex justify-space-between"
							>
								<div class="d-flex align-center">
									<PostAttachments
										backgroundColor="#F3F3F6"
										:attachment="attachment"
										style="margin-top: 5px"
									/>
									<span>{{ attachment.filename }}</span>
								</div>
								<button type="button" @click="removeFile(index)" class="delete-btn">
									<Icon type="delete" :size="24" color="#9B9B9B" />
								</button>
							</div>
						</div>
					</div>
					<div class="add-attachment">
						<button
							type="button"
							:disabled="!!fields.poll_question"
							@click="triggerFileInput"
							class="attachments__add-btn"
						>
							+ Add Attachments
						</button>
						<input
							type="file"
							ref="fileAttachmentInput"
							@change="handleFileAttachmentUpload"
							multiple
							:disabled="!!fields.poll_question"
							style="display: none"
						/>
					</div>
				</div>

				<div class="create-post__additional-container mt-3">
					<span class="title-video">Additional</span>
					<div class="create-post__additional-container__icon-container d-flex">
						<button @click="toggleImageSection" v-if="!isPollEdit" type="button">
							<Icon
								type="vector"
								:size="24"
								:color="
									slider_images.length > 0 || isImageSectionVisible
										? '#9b9b9b'
										: 'var(--primary_color)'
								"
							/>
						</button>
						<button v-if="!isPollEdit" @click="toggleAttachmentSection" type="button">
							<Icon
								type="clip"
								:size="24"
								:color="
									fields.upload_ids.length > 0 || isAttachmentSectionVisible
										? '#9b9b9b'
										: 'var(--primary_color)'
								"
							/>
						</button>
						<button @click="togglePollSection" type="button">
							<Icon
								type="forward"
								:size="24"
								:color="
									fields.poll_question.length > 0 || isPollSectionVisible
										? '#9b9b9b'
										: 'var(--primary_color)'
								"
							/>
						</button>
						<button type="button" @click="toggleTagsSection">
							<Icon
								type="hashtag"
								:size="20"
								:color="
									fields.tagNames.length > 0 || isTagsSectionVisible
										? '#9b9b9b'
										: 'var(--primary_color)'
								"
							/>
						</button>
						<button v-if="!isPollEdit" type="button" @click="toggleLinkSection">
							<Icon
								type="link"
								:size="24"
								:color="
									fields.thread_link || isLinkSectionVisible
										? '#9b9b9b'
										: 'var(--primary_color)'
								"
							/>
						</button>
						<button v-if="!isPollEdit" type="button" @click="toggleVideoSection">
							<Icon
								type="videolink"
								:size="24"
								:color="
									fields.thread_video || isVideoSectionVisible
										? '#9b9b9b'
										: 'var(--primary_color)'
								"
							/>
						</button>
					</div>
				</div>
				<div
					v-click-outside="closeErrorMessage"
					class="create-post__empty-container"
					v-if="isEmptyPost"
				>
					<h1 class="create-post__empty-container__title">{{ emptyPostText }}</h1>
				</div>
				<div class="create-post__btn-container mt-3">
					<button
						type="button"
						class="create-post__btn-container__left-button mr-3"
						@click="closeModal"
					>
						Cancel
					</button>
					<button
						class="create-post__btn-container__right-button ml-3"
						:style="{
							backgroundColor: isFormInvalid ? ' #9b9b9b' : 'var(--primary_color)',
						}"
						type="submit"
					>
						Publish
					</button>
				</div>

				<p
					class="red--text mt-2 mb-0"
					v-for="(error, index) in postErrors"
					:key="error + '-' + index"
					style="width: 100%"
				>
					{{ error.message }}
				</p>
			</div>
		</div>
	</v-form>
</template>

<script>
import { ruleVerifyVideo } from '@/utils/rules'
import Form from '@/mixins/Form'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import videoPreview from '@/assets/VideoPreview.png'
import PostAttachments from '@/components/Post/PostAttachments.vue'
import CustomCheckbox from '@/components/CustomCheckbox'
import CropperImage from '@/components/CropperImage.vue'
import ChaptersModal from '@/components/Modals/ChaptersModal.vue'

export default {
	name: 'PostTextForm',
	components: { ChaptersModal, CropperImage, PostAttachments, CustomCheckbox },
	mixins: [Form],

	props: {
		edit: {
			type: Boolean,
			default: false,
		},
		post: {
			type: Object,
			default: () => ({}),
		},
		chaptersList: {
			type: Object,
			default: () => ({}),
		},
	},

	data: () => ({
		isCropModal: false,
		cropSrc: '',
		errors: {
			thread_title: '',
			thread_text: '',
		},
		isEmptyPost: false,
		emptyPostText: '',
		isLinkSectionVisible: false,
		isTagsSectionVisible: false,
		isPollSectionVisible: false,
		isAttachmentSectionVisible: false,
		isVideoSectionVisible: false,
		isImageSectionVisible: false,
		isCustomImageLoading: false,
		isWrongLink: false,
		isVideoModal: false,
		selectedChapter: '',
		isAnswerModal: false,
		isHidePool: false,
		moreFiles: false,
		collapsed: false,
		maxVisibleLines: 5,
		threadVideoTemp: '',
		image_url: '',
		videoPreview,
		currentIndex: 0,
		slider_images: [],
		counter: 0,
		uploads: [],
		fields: {
			poll_length: null,
			poll_answers: [
				{
					poll_answer: '',
					poll_answer_id: '',
				},
			],
			poll_question: '',
			chapter_ids: [],
			thread_title: '',
			thread_text: '',
			thread_image: '',
			thread_video: '',
			thread_link: '',
			allow_comments: 1,
			thread_type: 1,
			tagNames: [],
			thread_menu_id: 1,
			thread_category_id: 1,
			publish_timestamp: Math.floor(Date.now() / 1000),
			image_upload_ids: [],
			upload_ids: [],
		},
		isChaptersIconHovered: false,
		isTypePost: false,
		chapter: null,
		menuProps: {
			maxWidth: '250px',
			offsetY: true,
		},
		chips: [],
		showConfirmDeleteImageButtons: false,
		timer: 0,
		isChaptersModal: false,
	}),

	computed: {
		...mapGetters('settings', ['isLoading', 'appCore', 'styles']),
		...mapGetters('post', [
			'isFileLoading',
			'postFile',
			'postErrors',
			'isPostUpdating',
			'postTimer',
			'pollTimerLoading',
			'videoLink',
			'videoLoading',
		]),
		...mapGetters('tag', ['tags']),
		...mapGetters('auth', ['profile']),
		chapterModalItem() {
			return this.edit ? this.post.initChapters?.chapterList : this.chaptersList?.chapterList
		},
		visibleChapters() {
			const list = this.edit
				? this.post.initChapters?.chapterList || []
				: this.chaptersList?.chapterList || []

			return list
				.filter((chapter) => this.fields.chapter_ids.includes(chapter.id))
				.map((chapter) => chapter.val)
				.join(', ')
		},
		trackStyle() {
			if (this.slider_images.length <= 1) {
				return { transform: 'translateX(0)' }
			}

			const slideWidth = this.$el?.querySelector('.carousel-item')?.offsetWidth || 0

			const gap = 8

			const shift = this.currentIndex * (slideWidth + gap)

			return {
				transform: `translateX(-${shift}px)`,
			}
		},

		isFormInvalid() {
			const {
				thread_title,
				thread_text,
				thread_image,
				thread_video,
				thread_link,
				poll_question,
				poll_answers,
				tagNames,
				upload_ids,
				image_upload_ids,
			} = this.fields || {}

			const hasTitle = (thread_title || '').trim()
			const hasText = (thread_text || '').trim()
			const hasImage = (thread_image || '').trim()
			const hasVideo = (thread_video || '').trim()
			const hasLink = (thread_link || '').trim()
			const hasPollQuestion = (poll_question || '').trim()

			const hasPollAnswers = Array.isArray(poll_answers)
				? poll_answers.some((item) => (item.poll_answer || '').trim() !== '')
				: false

			const hasTags = Array.isArray(tagNames) && tagNames.length > 0
			const hasAttachments = upload_ids.length > 0
			const hasSliderImages = Array.isArray(image_upload_ids) && image_upload_ids.length > 0

			return !(
				hasTitle ||
				hasText ||
				hasImage ||
				hasVideo ||
				hasLink ||
				hasPollQuestion ||
				hasPollAnswers ||
				hasTags ||
				hasAttachments ||
				hasSliderImages
			)
		},

		isPollEdit() {
			return this.edit && this.fields.thread_type === 4
		},

		isCustomImageUploaded() {
			return (
				this.fields.thread_image &&
				this.fields.thread_image !== this.videoLink?.videoThumbnail
			)
		},

		poolArray() {
			if (!this.isHidePool) {
				return this.fields.poll_answers
			} else {
				return this.fields.poll_answers.slice(0, 3)
			}
		},
		isLongText() {
			return this.fields.thread_text.split('\n').length > this.maxVisibleLines
		},
		trimmedText() {
			if (this.isLongText && this.collapsed) {
				return (
					this.fields.thread_text.split('\n').slice(0, this.maxVisibleLines).join('\n') +
					'...'
				)
			}
			return this.fields.thread_text
		},
		selectedPollLength() {
			const selected = this.postTimer.find((item) => item.id === this.fields.poll_length)
			return selected ? selected.val : ''
		},

		rules() {
			return {
				verifyVideo: [
					(v) => {
						if (!v) return true
						return (
							ruleVerifyVideo(v) ||
							'Video link is incorrect. You must specify a Vimeo or YouTube video link.'
						)
					},
				],
			}
		},

		tagSelectItems() {
			return this.tags.map((item) => item.tag)
		},
	},

	watch: {
		chapter: {
			handler(newVal) {
				this.selectedChapter = newVal ? JSON.stringify(newVal) : ''
			},
			deep: true,
			immediate: true,
		},
	},

	methods: {
		...mapActions('post', ['addPost', 'uploadFile', 'editPost', 'getPollTimer', 'videoUpload']),
		...mapActions('tag', ['fetchTags']),
		openChaptersModal() {
			this.isChaptersModal = true
		},
		closeChaptersModal() {
			this.isChaptersModal = false
		},
		autoResize(event) {
			const textarea = event.target
			textarea.style.height = 'auto'
			textarea.style.height = textarea.scrollHeight + 'px'
		},
		triggerPhotoInput() {
			this.$refs.photoInput.click()
		},
		triggerPreview() {
			this.$refs.addPreview.click()
		},
		closeErrorMessage() {
			this.isEmptyPost = false
		},
		toggleLinkSection() {
			this.isLinkSectionVisible = !this.isLinkSectionVisible
			if (this.isLinkSectionVisible) {
				this.isPollSectionVisible = false
				this.fields.poll_question = ''
				this.fields.poll_answers = [{ poll_answer: '', poll_answer_id: '' }]
				if (this.isLinkSectionVisible) {
					this.$nextTick(() => {
						this.$refs.linkInput?.focus()
					})
				}
			}
		},
		toggleTagsSection() {
			this.isTagsSectionVisible = !this.isTagsSectionVisible
			if (this.isTagsSectionVisible) {
				this.$nextTick(() => {
					this.$refs.tagsInput?.focus()
				})
			}
		},
		togglePollSection() {
			this.isPollSectionVisible = !this.isPollSectionVisible
			if (this.isPollSectionVisible) {
				this.isVideoSectionVisible = false
				this.isImageSectionVisible = false
				this.isAttachmentSectionVisible = false
				this.isLinkSectionVisible = false
				this.fields.thread_link = ''
				this.fields.thread_video = ''
				this.uploads = []
				this.fields.upload_ids = []
				this.fields.slider_images = []
				this.fields.image_upload_ids = []
				this.slider_images = []
				this.$nextTick(() => {
					const firstInput = this.$refs['pollInput']
					if (firstInput && !this.isPollEdit) {
						firstInput.focus()
					}
				})
			}
		},
		toggleAttachmentSection() {
			this.isAttachmentSectionVisible = !this.isAttachmentSectionVisible
			if (this.isAttachmentSectionVisible) {
				this.isPollSectionVisible = false
				this.isVideoSectionVisible = false
				this.fields.poll_question = ''
				this.fields.poll_answers = [{ poll_answer: '', poll_answer_id: '' }]
				this.$nextTick(() => {
					if (this.$refs.fileAttachmentInput) {
						this.$refs.fileAttachmentInput.focus()
					}
				})
			}
		},
		toggleImageSection() {
			this.isImageSectionVisible = !this.isImageSectionVisible
			if (this.isImageSectionVisible) {
				this.isVideoSectionVisible = false
				this.isPollSectionVisible = false
				this.fields.thread_image = ''
				this.fields.thread_video = ''
				this.fields.poll_question = ''
				this.fields.poll_answers = [{ poll_answer: '', poll_answer_id: '' }]
				this.$nextTick(() => {
					if (this.$refs.photoInput) {
						this.$refs.photoInput.focus()
					}
				})
			}
		},
		toggleVideoSection() {
			this.isVideoSectionVisible = !this.isVideoSectionVisible
			if (this.isVideoSectionVisible) {
				this.isPollSectionVisible = false
				this.isImageSectionVisible = false
				this.slider_images = []
				this.fields.image_upload_ids = []
				this.fields.poll_question = ''
				this.fields.poll_answers = [{ poll_answer: '', poll_answer_id: '' }]
				this.$nextTick(() => {
					requestAnimationFrame(() => {
						const el = this.fields.thread_video === '' ? this.$refs.videoLinkValue : ''
						if (el && el.focus) {
							el.focus()
						}
					})
				})
			}
		},
		closeWrongVideoModal() {
			this.isWrongLink = false
			this.isVideoModal = true
		},
		openVideoModal() {
			this.isVideoModal = !this.isVideoModal
		},
		async addVideoPreview() {
			if (this.fields.thread_video === '') return
			await this.videoUpload(this.fields.thread_video)
			if (this.videoLink.success === false) {
				this.isVideoModal = false
				this.fields.thread_video = ''
				this.fields.thread_image = ''
				this.isWrongLink = true
			} else {
				this.fields.thread_image = this.videoLink.videoThumbnail
				this.isVideoModal = false
			}
		},
		removeCustomImage() {
			if (this.isCustomImageUploaded) {
				this.fields.thread_image = this.videoLink?.videoThumbnail || ''
			}
		},
		setPollLength(id) {
			this.fields.poll_length = id
			this.isAnswerModal = false
		},
		toggleAnswerModal() {
			if (this.edit) return
			this.isAnswerModal = !this.isAnswerModal
		},
		formatThreadLink() {
			if (
				this.fields.thread_link &&
				!this.fields.thread_link.startsWith('http://') &&
				!this.fields.thread_link.startsWith('https://')
			) {
				this.fields.thread_link = `https://${this.fields.thread_link}`
			}
		},
		hidePool() {
			this.isHidePool = !this.isHidePool
		},
		clearPoll() {
			if (this.isPollEdit) return
			this.fields.poll_length = null
			this.fields.poll_question = ''
			this.fields.poll_answers = [{ poll_answer: '', poll_answer_id: '' }]
			this.isPollSectionVisible = false
		},
		addAnswer() {
			this.fields.poll_answers.push({ poll_answer: '', poll_answer_id: null })
		},
		removeAnswer(index) {
			if (this.isPollEdit) return
			this.fields.poll_answers.splice(index, 1)
		},
		toggleAttachments() {
			this.moreFiles = !this.moreFiles
		},
		toggleDescription() {
			this.collapsed = !this.collapsed
		},

		clearAttachments() {
			this.uploads = []
			this.fields.upload_ids = []
			this.isAttachmentSectionVisible = false
		},
		triggerFileInput() {
			this.$refs.fileAttachmentInput.click()
		},

		async handleFileAttachmentUpload(event) {
			const file = event.target.files[0]
			await this.uploadFile(file)
			this.uploads = [...this.uploads, this.postFile]
			this.fields.upload_ids.push(this.postFile.upload_id)
		},

		async handleFileUpload(event) {
			const fileInput = event.target
			const file = fileInput.files[0]
			this.cropSrc = URL.createObjectURL(file)
			this.isCropModal = true
			fileInput.value = ''
		},

		async onCropped(blob) {
			URL.revokeObjectURL(this.cropSrc)
			this.cropSrc = ''
			this.isCropModal = false
			this.$refs.photoInput && (this.$refs.photoInput.value = '')

			const file = new File([blob], `cropped_${Date.now()}.jpg`, { type: blob.type })
			await this.uploadFile(file)
			this.slider_images.push({
				image_url: this.postFile.url,
				id: this.slider_images.length,
			})
			this.fields.image_upload_ids.push(this.postFile.upload_id)
			this.currentIndex = this.slider_images.length - 1
		},
		closeCropper() {
			URL.revokeObjectURL(this.cropSrc)
			this.cropSrc = ''
			this.isCropModal = false
		},
		removeFile(index) {
			this.uploads.splice(index, 1)
			this.fields.upload_ids.splice(index, 1)
		},
		clearAllPhotos() {
			this.slider_images = []
			this.fields.image_upload_ids = []
			this.isImageSectionVisible = false
		},
		removeImages(index) {
			this.slider_images.splice(index, 1)
			this.fields.image_upload_ids.splice(index, 1)
			if (this.currentIndex >= this.slider_images.length) {
				this.currentIndex = this.slider_images.length - 1
			}
			this.$refs.photoInput && (this.$refs.photoInput.value = '')
		},
		goToSlide(index) {
			this.currentIndex = index
		},
		deleteLink() {
			this.fields.thread_link = ''
			this.isLinkSectionVisible = false
		},
		deleteTags() {
			this.chips = []
			this.fields.tagNames = []
			this.isTagsSectionVisible = false
		},
		setEmptyPost(message) {
			this.isEmptyPost = true
			this.emptyPostText = message
		},
		resetSections() {
			this.isVideoSectionVisible = false
			this.isLinkSectionVisible = false
			this.isTagsSectionVisible = false
			this.isPollSectionVisible = false
			this.isAttachmentSectionVisible = false
			this.isImageSectionVisible = false
		},
		async submitForm() {
			if (this.isFormInvalid) {
				this.setEmptyPost('Your post is empty')
				return false
			}
			if (this.fields.thread_title?.length >= 256) {
				this.setEmptyPost('Title should contain at most 256 characters.')
				return false
			}
			if (this.fields.poll_question.trim()) {
				const hasAtLeastOneAnswer = this.fields.poll_answers.some(
					(answer) => (answer.poll_answer || '').trim() !== ''
				)

				if (!hasAtLeastOneAnswer) {
					this.setEmptyPost('Have at least one answer')
					return false
				}

				if (this.fields.poll_length === null) {
					this.setEmptyPost('Have a poll length')
					return false
				}
			}
			if (this.fields.thread_video) {
				this.fields.thread_type = 3
			} else if (this.fields.poll_question) {
				this.fields.thread_type = 4
			} else {
				this.fields.thread_type = 1
			}

			if (this.edit) {
				const thread_menu_id = +this.$route.query.thread_menu_id || this.post.thread_menu_id
				const thread_category_id =
					+this.$route.query.category_id || this.post.thread_category_id
				await this.editPost({
					id: this.post.thread_id,
					data: {
						...this.fields,
						thread_menu_id,
						thread_category_id,
					},
				})
			} else {
				await this.addPost(this.fields)
				this.$emit('postCreated')
				this.resetSections()
				this.closeModal()
			}
			this.resetSections()
			this.closeModal()
		},
		remove(item) {
			this.chips.splice(this.chips.indexOf(item), 1)
		},
		handlerInputTag(item) {
			clearTimeout(this.timer)
			this.timer = setTimeout(() => {
				this.fetchTags({ search: item, filter: 'threads' })
			}, 500)
		},
		removeImage() {
			this.fields.thread_image = ''
			this.fields.thread_video = ''
			this.isVideoSectionVisible = false
		},
		handlerAllowComments(value) {
			this.fields.allow_comments = _.toNumber(value)
		},
		closeModal() {
			if (this.videoLink?.videoThumbnail) {
				this.videoLink.videoThumbnail = ''
			}
			this.$emit('closeModal')
		},
		async handleUploadFile(e) {
			this.isCustomImageLoading = true
			const file = e.target.files[0]
			await this.uploadFile(file)
			this.fields.thread_image = this.postFile.url || this.videoLink?.videoThumbnail
			this.isCustomImageLoading = false
		},

		debug(values) {
			this.fields.tagNames = values
		},
		initEditForm() {
			const post = this.post
			const fields = this.fields

			fields.allow_comments = post.allow_comments
			fields.chapter_ids = post.chapter_ids
			fields.thread_title = post.thread_title
			fields.thread_text = post.thread_text
			fields.thread_type = post.thread_type
			fields.thread_category_id = post.thread_category_id
			fields.thread_menu_id = post.thread_menu_id

			if (post.thread_type === 4 && post.poll) {
				fields.poll_answers = post.poll.pollsAnswers.map((answer) => ({
					poll_answer: answer.poll_answer,
					poll_answer_id: answer.poll_answer_id,
				}))
				fields.poll_question = post.poll.poll_question || ''
				fields.poll_length = post.poll.poll_length
			} else {
				fields.poll_answers = [{ poll_answer: '', poll_answer_id: '' }]
				fields.poll_question = ''
			}
			const chapterList = post.initChapters?.chapterList || []

			this.chapter =
				chapterList.find((chapter) => post.chapter_ids.includes(chapter.id)) || null
			const tags = post.tags || []
			this.chips = tags.map((tag) => tag.tag)
			fields.tagNames = [...this.chips]
			if (post.thread_type !== 4) {
				fields.thread_video = post.thread_video
				fields.thread_link = post.thread_link
				fields.thread_image = post.thread_image

				this.uploads = post.uploads || []
				fields.upload_ids = this.uploads.map((upload) => upload.upload_id)

				this.slider_images = (post.slider_images || []).map((image, index) => ({
					image_url: image.image_url,
					id: image.upload_id || index,
				}))

				fields.image_upload_ids = this.slider_images.map((img) => img.id)
			}

			this.isLinkSectionVisible = !!fields.thread_link
			this.isTagsSectionVisible = fields.tagNames.length > 0
			this.isPollSectionVisible = !!fields.poll_question
			this.isAttachmentSectionVisible = fields.upload_ids.length > 0
			this.isVideoSectionVisible = !!fields.thread_video
			this.isImageSectionVisible = this.slider_images.length > 0 && post.thread_type === 1
		},

		resetForm() {
			this.initEditForm()
			this.fields.thread_menu_id = +this.$route.query.thread_menu_id
			this.fields.thread_category_id = +this.$route.query.category_id
		},
	},

	created() {
		this.getPollTimer()
		if (this.appCore) {
			this.fields.thread_menu_id = +this.$route.query.thread_menu_id
			this.fields.thread_category_id = +this.$route.query.category_id
		}
	},

	mounted() {
		if (this.edit && this.post) {
			this.initEditForm()
		}
		if (this.fields.poll_question) {
			this.$nextTick(() => {
				const textarea = document.querySelector('#poll_text')
				if (textarea) {
					textarea.style.height = 'auto'
					textarea.style.height = textarea.scrollHeight + 'px'
				}
			})
		}
		if (!this.edit && !this.fields.chapter_ids.length) {
			const defaultIds = this.chaptersList?.defaultIds || []
			this.fields.chapter_ids = defaultIds

			const defaultChapter = this.chaptersList?.chapterList.find((chapter) =>
				defaultIds.includes(chapter.id)
			)

			this.chapter = defaultChapter || null
			this.selectedChapter = defaultChapter ? JSON.stringify(defaultChapter) : ''
		}
	},
}
</script>

<style lang="scss">
.wrong-video-link-container {
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 588px;
	height: 168px;
	padding: 24px;
	align-items: center;
	justify-content: center;
	background-color: #ffffff;

	&__title {
		font-family: Inter, sans-serif;
		font-weight: 700;
		line-height: 100%;
		font-size: 24px;
		color: #4a4a4a;
		margin-bottom: 8px;
		white-space: nowrap;
	}

	&__button {
		margin-top: 16px;
		width: 115px;
		height: 48px;
		background-color: #002855;
		border-radius: 8px;
		font-family: Inter, sans-serif;
		font-weight: 700;
		line-height: 100%;
		font-size: 18px;
		color: #ffffff;
	}
}

.video-modal-container {
	padding: 24px;
	display: flex;
	flex-direction: column;

	&__input-container {
		display: flex;
		flex-direction: column;
		padding: 12px;
		border-radius: 8px;
		border: 1px solid #e2e2e2;

		&__title {
			font-family: Inter, sans-serif;
			font-weight: 500;
			line-height: 100%;
			font-size: 18px;
			color: #4a4a4a;
			margin-bottom: 8px;
		}

		&__input {
			font-family: Inter, sans-serif;
			font-weight: 400;
			line-height: 100%;
			font-size: 18px;
			color: #4a4a4a;

			&::placeholder {
				color: #9b9b9b;
				font-weight: 400;
				font-size: 18px;
				line-height: 100%;
			}

			&:focus {
				border: none;
				outline: none;
			}
		}
	}

	&__buttons {
		width: 100%;
		display: flex;
		justify-content: center;
		gap: 16px;
		margin-top: 24px;

		&__save-button {
			width: 100%;
			max-width: 131px;
			height: 46px;
			border-radius: 8px;
			color: #ffffff;
			font-family: 'Inter', sans-serif;
			font-size: 18px;
			font-weight: 700;
			line-height: 100%;
		}

		&__cancel-button {
			width: 100%;
			max-width: 150px;
			height: 46px;
			border-radius: 8px;
			background-color: #ffffff;
			border: 1.5px solid var(--accent-color);
			color: var(--accent-color);
			font-family: 'Inter', sans-serif;
			font-size: 18px;
			font-weight: 700;
			line-height: 100%;
		}
	}
}

.pool-container {
	margin-top: 12px;
	width: 100%;
	height: 100%;
	padding: 12px;
	background-color: #ffffff;
	border-radius: 8px;
	border: 1px solid #e2e2e2;

	&__pool_group {
		padding: 12px;
		border-radius: 8px;
		background-color: #f3f3f6;

		&__button {
			font-family: Inter, sans-serif;
			font-weight: 700;
			line-height: 21.78px;
			font-size: 18px;
		}

		&__number {
			font-family: Inter, sans-serif;
			font-weight: 500;
			line-height: 19.36px;
			font-size: 16px;
			color: #4a4a4a;
		}

		&__input {
			margin-top: 8px;
			font-family: Inter, sans-serif;
			font-weight: 400;
			line-height: 21.78px;
			font-size: 18px;
			color: #9b9b9b;

			&::placeholder {
				color: #9b9b9b;
				font-family: Inter, sans-serif;
				font-weight: 400;
				font-size: 18px;
				line-height: 21.78px;
			}

			&:focus {
				outline: none;
			}
		}

		&__input-container {
			display: flex;
			flex-direction: column;
			width: -webkit-fill-available;
		}
	}

	&__answer-container {
		&__end-time {
			margin-top: 12px;
			width: 100%;
			height: 24px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			position: relative;

			&__modal {
				top: 30px;
				width: 100%;
				height: 156px;
				border-radius: 8px;
				background-color: #ffffff;
				border: 1px solid #e2e2e2;
				position: absolute;
				z-index: 100;
				padding: 12px;

				&__container {
					display: flex;
					flex-direction: column;
					justify-content: space-around;
					height: 100%;
				}

				&__item {
					display: flex;
					align-items: center;
					padding: 12px;
				}

				&__item-label {
					font-family: Inter, sans-serif;
					font-weight: 400;
					line-height: 16.94px;
					font-size: 14px;
					color: #4a4a4a;
					margin-left: 5px;
				}
			}

			&__button {
				display: flex;
				align-items: center;
				font-family: Inter, sans-serif;
				font-weight: 400;
				line-height: 21.78px;
				font-size: 18px;
				color: #9b9b9b;
			}

			&__label {
				font-family: Inter, sans-serif;
				font-weight: 500;
				line-height: 21.78px;
				font-size: 18px;
				color: #4a4a4a;
			}

			&__input {
				padding: 0 !important;
			}

			.v-select__selection--comma {
				font-family: Inter, sans-serif;
				font-weight: 400;
				line-height: 21.78px;
				font-size: 18px !important;
				color: #9b9b9b !important;
			}

			.v-input__slot {
				margin-top: 9px;
			}

			.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
				> .v-input__control
				> .v-input__slot {
				padding: unset !important;
			}

			.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
				> .v-input__control
				> .v-input__slot {
				box-shadow: unset !important;
			}
		}

		&__input {
			color: #4a4a4a;
			font-family: Inter, sans-serif;
			font-weight: 500;
			line-height: 21.78px;
			font-size: 18px;
			border: unset;

			&::placeholder {
				color: #9b9b9b;
			}

			&:focus {
				outline: none;
			}
		}

		&__input-container {
			display: flex;
			flex-direction: column;
		}

		&__label {
			font-family: Inter, sans-serif;
			font-weight: 500;
			line-height: 19.36px;
			font-size: 18px;
			color: #9b9b9b;
		}
	}

	&__title-container {
		display: flex;
		justify-content: space-between;

		&__title {
			font-family: Inter, sans-serif;
			font-weight: 500;
			line-height: 21.78px;
			font-size: 18px;
			color: #4a4a4a;
		}

		&__icon-container {
			display: flex;
		}
	}
}

.attachments {
	margin-top: 12px;
	width: 100%;
	border: 1px solid #e2e2e2;
	padding: 12px;
	border-radius: 8px;

	&__add-btn {
		margin-top: 12px;
		font-family: Inter, sans-serif;
		font-weight: 700;
		line-height: 21.78px;
		font-size: 18px;
		color: var(--text_button_tint);
	}

	&__attachments-list {
		margin-top: 12px;
	}
}

.carousel-button {
	width: 100%;
	display: flex;
	position: relative;
	font-family: Inter, sans-serif;
	font-weight: 700;
	line-height: 21.78px;
	font-size: 18px;
	color: var(--text_button_tint);

	input[type='file'] {
		opacity: 0;
		cursor: pointer;
	}
}

.carousel-wrapper {
	border: 1px solid #e2e2e2;
	width: 100%;
	max-height: 100%;
	text-align: center;
	padding: 12px;
	border-radius: 8px;

	&__file-container-description {
		font-weight: 500;
		font-family: Inter, sans-serif;
		font-size: 13px;
		color: #9b9b9b;
		line-height: 15.73px;
		margin-top: 5px;
	}

	&__file-container-title {
		font-size: 16px;
		font-weight: 700;
		line-height: 22px;
		color: #333;
		font-family: Inter, sans-serif;
	}

	&__file-container {
		border-radius: 4px;
		gap: 4px;
		display: flex;
		flex-direction: column;
		align-items: center;
		border: 1px dashed #e2e2e2;
		height: 200px;
		justify-content: center;
	}
}
.carousel {
	overflow: hidden;
	border-radius: 8px;
	height: 250px;
}

.carousel-track {
	display: flex;
	transition: transform 0.4s ease;
}
.carousel-item:not(.single) {
	flex: 0 0 85%;
	max-width: 85%;
	margin-right: 8px;
}

.carousel-item {
	flex: 0 0 100%;
	max-width: 100%;
	position: relative;

	&.single {
		flex: 0 0 100%;
		margin-right: 0;
	}

	img {
		width: 100%;
		height: 250px;
		object-fit: cover;
		border-radius: 8px;
	}
}

.remove-btn {
	display: flex;
	justify-content: center;
	padding: 8px;
	align-items: center;
	position: absolute;
	top: 10px;
	right: 10px;
	background-color: white;
	border: 1px solid #e2e2e2;
	border-radius: 8px;
	cursor: pointer;
	width: 40px;
	height: 40px;
	z-index: 100;
}

.indicators {
	display: flex;
	justify-content: center;
	gap: 5px;
	margin-top: 10px;
	height: 10px;
}

.indicators span {
	width: 10px;
	height: 10px;
	background-color: #ccc;
	border-radius: 50%;
	cursor: pointer;
	transition: background-color 0.3s;
}

.indicators span.active {
	background-color: var(--primary_color);
}

.create-post-form .theme--light.v-input input {
	font-family: Inter, sans-serif !important;
	font-weight: 400 !important;
	font-size: 18px !important;
	line-height: 21.78 !important;
	color: #4a4a4a !important;
	user-select: none !important;
}

.create-post {
	&__empty-container {
		margin-top: 8px;
		display: flex;
		width: 100%;
		justify-content: center;

		&__title {
			font-family: Inter, sans-serif;
			font-weight: 500;
			line-height: 21.78px;
			font-size: 18px;
			color: red;
		}
	}

	&__create-preview {
		margin-top: 12px;
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		line-height: 21.78px;
		font-size: 18px;
		color: var(--primary_color);

		input[type='file'] {
			display: none;
		}
	}
	&__chapters-container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 8px;
		padding: 12px;
		border: 1px solid #e2e2e2;
		border-radius: 8px;
		&__info {
			display: flex;
			flex-direction: column;
			gap: 8px;
			&__chapters {
				display: flex;
				&__chapter {
					font-family: 'Inter', sans-serif;
					font-weight: 400;
					font-size: 18px;
					line-height: 100%;
					letter-spacing: 0;
					color: #4a4a4a;
				}
			}
		}
	}
	&__title-container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		border: 1px solid #e2e2e2;
		border-radius: 8px;
		padding: 12px 12px 0 12px;
		background-color: #ffffff;

		&__field-title {
			font-family: Inter, sans-serif;
			font-weight: 500;
			line-height: 21.78px;
			font-size: 18px;
			color: #4a4a4a;
		}
		input {
			padding: 0 !important;
			height: 22px !important;
			line-height: 120% !important;
		}

		.v-input__slot {
			padding: 0 !important;
			min-height: 29px !important;
		}

		.v-text-field.v-text-field--solo .v-input__control {
			min-height: 39px !important;
		}

		.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
			> .v-input__control
			> .v-input__slot {
			box-shadow: unset !important;
			margin-bottom: 0;
		}
	}

	&__descript-container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		border: 1px solid #e2e2e2;
		border-radius: 8px;
		padding: 12px;
		background-color: #ffffff;

		v-input input {
			font-family: Inter, sans-serif !important;
			font-weight: 400 !important;
			font-size: 18px !important;
			line-height: 21.78 !important;
			color: #4a4a4a !important;
		}

		.v-textarea textarea {
			font-family: Inter, sans-serif !important;
			font-weight: 400 !important;
			font-size: 18px !important;
			line-height: 21.78px !important;
			color: #4a4a4a !important;
			min-height: 96px !important;
			margin-top: 0 !important;
		}

		&__field-title {
			font-family: Inter, sans-serif;
			font-weight: 500;
			line-height: 21.78px;
			font-size: 18px;
			color: #4a4a4a;
		}

		.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
			> .v-input__control
			> .v-input__slot {
			box-shadow: unset !important;
			margin-bottom: 0;
		}

		.v-input__slot {
			padding: 0 0 10px 0 !important;
			min-height: 29px !important;
		}
	}

	&__group-container {
		display: flex;
		justify-content: space-between;
		border: 1px solid #e2e2e2;
		align-items: center;
		border-radius: 8px;
		padding: 12px;
		height: 48px;

		&__field-title {
			font-family: Inter, sans-serif;
			font-weight: 500;
			line-height: 21.78px;
			font-size: 18px;
			color: #4a4a4a;
		}

		.v-text-field .v-input__prepend-inner,
		.v-text-field .v-input__append-inner {
			margin-top: 6px;
		}

		v-icon.v-icon {
			margin-left: 5px;
		}

		.v-select__selection--comma {
			overflow: unset;
		}
	}

	&__link-container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		border: 1px solid #e2e2e2;
		border-radius: 8px;
		padding: 12px 12px 0 12px;

		.v-input__slot {
			padding: 0 !important;
			min-height: 29px !important;
		}

		.v-text-field.v-text-field--solo .v-input__control {
			min-height: 39px !important;
		}

		.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
			> .v-input__control
			> .v-input__slot {
			box-shadow: unset !important;
			margin-bottom: 0;
		}
	}

	&__tags-container {
		display: flex;
		flex-direction: column;
		border: 1px solid #e2e2e2;
		padding: 12px 12px 0 12px;
		border-radius: 8px;
		&__custom-tag {
			.v-input__append-inner {
				.v-icon {
					color: #9b9b9b !important;
					transform: none !important;
					transition: none !important;
					cursor: pointer;
				}
			}
		}
		&__tags-combobox {
			.v-list-item--active {
				.v-simple-checkbox {
					.v-icon {
						color: var(--secondary_color) !important;
					}
				}
			}
		}

		.theme--light.v-chip:not(.v-chip--active) {
			border: 1.5px solid #e2e2e2;
			background-color: #ffffff;
			font-family: Inter, sans-serif;
			font-size: 13px;
			line-height: 15.37px;
			font-weight: 300;
			color: #002855;
		}

		.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
			> .v-input__control
			> .v-input__slot {
			box-shadow: unset !important;
			margin-bottom: 0;
		}

		.v-input__slot {
			padding: 0 !important;
			min-height: 29px !important;
		}
	}

	&__file-wrapper {
		display: flex;
		flex-direction: column;
		border: 1px solid #e2e2e2;
		padding: 12px;
		border-radius: 8px;

		&__file-container__images {
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 0 auto;
			position: relative;
			max-height: 287px;
			overflow: hidden;

			&__image {
				width: 100%;
				height: 100%;
				object-fit: cover;

				&__button {
					display: flex;
					justify-content: center;
					padding: 8px;
					align-items: center;
					position: absolute;
					right: 5px;
					top: 5px;
					background-color: white;
					border: 1px solid #e2e2e2;
					border-radius: 8px;
					cursor: pointer;
					width: 40px;
					height: 40px;
					z-index: 100;
				}
			}

			&__mdi-close {
				width: 40px;
				height: 40px;
				border-radius: 8px;
				padding: 8px;
				border: 1px solid #e2e2e2;
				background-color: #ffffff;
				position: absolute !important;
				top: 5px;
				right: 5px;
			}
		}

		&__preview-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			height: 100%;
			max-height: 300px;
		}

		&__file-container-preview {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			v-icon {
				color: #007bff;
			}
		}

		.create-post__file-container-title {
			font-size: 16px;
			font-weight: 700;
			line-height: 22px;
			color: #333;
			font-family: Inter, sans-serif;
		}

		.create-post__file-container-description {
			font-weight: 500;
			font-family: Inter, sans-serif;
			font-size: 13px;
			color: #9b9b9b;
			line-height: 15.73px;
			margin-top: 5px;
		}
	}

	&__video-container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		border: 1px solid #e2e2e2;
		border-radius: 8px;
		padding: 12px;
		background-color: #ffffff;

		&__field {
			margin-top: 8px;
			font-family: 'Inter', sans-serif;
			font-weight: 400;
			font-size: 18px;
			line-height: 100%;
			color: #9b9b9b;
		}

		&__videoLink {
			margin-top: 8px;
			font-family: 'Inter', sans-serif;
			font-weight: 400;
			font-size: 18px;
			line-height: 100%;
			color: #9b9b9b;

			&:hover {
				color: var(--primary_color);
			}
		}

		&__preview {
			font-family: Inter, sans-serif;
			font-weight: 700;
			line-height: 21.78px;
			font-size: 18px;
			color: var(--button-icon-tint);
			position: relative;

			input[type='file'] {
				position: absolute;
				top: 0;
				left: 12px;
				opacity: 0;
				cursor: pointer;
				width: 29%;
				height: 105%;
			}
		}

		.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
			> .v-input__control
			> .v-input__slot {
			box-shadow: unset !important;
			margin-bottom: 0;
		}

		.v-input__slot {
			padding: 0 !important;
			min-height: 29px !important;
		}

		.v-text-field.v-text-field--solo .v-input__control {
			min-height: 39px !important;
		}
	}

	&__additional-container {
		display: flex;
		border: 1px solid #e2e2e2;
		border-radius: 8px;
		height: 54px;
		width: 100%;
		padding: 7px 12px;
		align-items: center;
		justify-content: space-between;

		&__icon-container {
			display: flex;
			gap: 24px;

			@media (max-width: 1200px) {
				gap: 16px;
			}

			@media (max-width: 768px) {
				gap: 12px;
			}

			@media (max-width: 480px) {
				gap: 2px;
			}
		}
	}

	&__btn-container {
		display: flex;
		width: 100%;
		justify-content: center;

		&__left-button {
			display: flex;
			align-items: center;
			width: 150px;
			white-space: nowrap !important;
			max-height: 46px;
			border-radius: 8px;
			padding: 12px 44px 12px 44px;
			border: 1.5px solid var(--secondary_color);
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 18px;
			line-height: 21.78px;
			color: var(--secondary_color);
		}

		&__right-button {
			display: flex;
			width: 146px;
			max-height: 46px;
			border-radius: 8px;
			padding: 12px 44px 12px 44px;
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 18px;
			line-height: 21.78px;
			color: #ffffff;
		}
	}
}

.title-video {
	font-size: 18px;
	font-weight: 500;
	line-height: 21.78px;
	color: #4a4a4a;
	font-family: Inter, sans-serif;
}

.text-collapsed {
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 5;
	-webkit-box-orient: vertical;
	font-family: Inter, sans-serif;
	font-weight: 400;
	font-size: 18px;
	line-height: 21.78px;
	color: #4a4a4a;
}

.custom-select {
	input {
		opacity: 0;
		pointer-events: none;
		height: 0;
		width: 0;
		position: absolute;
	}
	.custom-v-select {
		.v-input__control {
			min-height: 48px;
		}
		.v-input__append-inner {
			margin-top: 0;
		}
		.v-icon {
			color: #9b9b9b !important;
			margin-right: 8px !important;
		}

		.v-input__slot {
			margin-top: 4px;
			min-height: 40px;
			box-shadow: unset !important;
		}
		.v-select__selections {
			flex: 1;
			font-size: 18px;
			color: #9b9b9b;
			padding-right: 8px;
		}

		.v-select__selection {
			font-size: 18px;
			color: #9b9b9b;
		}
		.v-icon {
			margin: 0 !important;
		}
	}
}

.create-post__video-container:focus {
	outline: 2px solid red;
}
</style>
